export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface MangaData {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  category: '日漫' | '韩漫' | '国漫';
  tags: string[];
  rating: number;
  views: number;
  updatedAt: string;
  chapters: MangaChapter[];
  isHot: boolean;
  isNew: boolean;
  rank?: number;
}

export const allManga: MangaData[] = [
  {
    id: '1',
    slug: 'oni-no-ha',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%20illustration%20of%20a%20young%20warrior%20holding%20a%20katana%20sword%20with%20water%20dragon%20effects%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20dark%20blue%20color%20palette%2C%20clean%20composition%20with%20character%20centered%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20manga%20illustration%20quality%2C%20dramatic%20lighting%20from%20above&width=800&height=1100&seq=manga-cover-01&orientation=portrait',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。母亲与四个弟妹惨遭杀害，而与他一起生还的妹妹祢豆子亦异变成凶暴的鬼。在猎鬼人的指引下，立志成为猎鬼人的炭治郎与变成鬼却尚存理智的祢豆子踏上了旅程。通过艰苦的剑术修行与赌命试炼，炭治郎成为了猎鬼人组织"鬼杀队"的一员。',
    status: '已完结',
    category: '日漫',
    tags: ['热血', '战斗', '奇幻', '少年'],
    rating: 9.6,
    views: 15800000,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 205 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-28',
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    slug: 'jujutsu-kaisen',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20teenage%20boy%20with%20spiky%20hair%20surrounded%20by%20dark%20energy%20and%20curse%20marks%2C%20modern%20urban%20fantasy%20aesthetic%2C%20red%20and%20black%20color%20scheme%2C%20intense%20facial%20expression%2C%20clean%20minimal%20background%20with%20gradient%2C%20professional%20manga%20art%20quality&width=800&height=1100&seq=manga-cover-02&orientation=portrait',
    description: '少年战斗着——「为了寻求正确的死亡」。辛酸·后悔·耻辱。人类产生的负面情感，化为诅咒，潜入日常生活。诅咒是蔓延于世界的祸源，最糟糕的情况下，会让人类踏入死亡。并且，诅咒只能以诅咒祓除。拥有惊人身体能力的少年·虎杖悠仁原本过着普通的高中生活。有一天，为了拯救被"诅咒"袭击的同伴，他吃下了特级咒物"两面宿傩之指"，让诅咒寄宿于自己的灵魂之中。',
    status: '连载中',
    category: '日漫',
    tags: ['热血', '战斗', '校园', '超能力'],
    rating: 9.5,
    views: 14200000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 268 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-02',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    slug: 'one-piece',
    title: '海贼王',
    author: '尾田荣一郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20a%20cheerful%20pirate%20boy%20with%20a%20straw%20hat%2C%20fist%20raised%20in%20adventure%20pose%2C%20ocean%20blue%20sky%20background%20with%20soft%20clouds%2C%20warm%20golden%20sunlight%2C%20joyful%20and%20energetic%20manga%20art%20style%2C%20clean%20composition&width=800&height=1100&seq=manga-cover-03&orientation=portrait',
    description: '拥有财富、名声、权力，这世界上的一切的男人——"海贼王"哥尔·D·罗杰，在被行刑受死之前说了一句话，让全世界的人都涌向了大海：「想要我的宝藏吗？如果想要的话，那就到海上去找吧，我全部都放在那里。」，世界开始迎接"大海贼时代"的来临。为了寻找传说中海贼王罗杰所留下的大秘宝"ONE PIECE"，无数海贼扬起旗帜，互相争斗。有一个梦想成为海贼王的少年路飞，因误食"恶魔果实"而成为了橡皮人，在获得超人能力的同时也付出了一辈子无法游泳的代价。十年后，路飞为实现与救了他一命的"红发"杰克的约定而出海，他在旅途中不断寻找志同道合的伙伴，开始了以成为海贼王为目标的冒险旅程。',
    status: '连载中',
    category: '日漫',
    tags: ['热血', '冒险', '友情', '奇幻'],
    rating: 9.7,
    views: 22500000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 1122 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-03',
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    slug: 'shingeki-no-kyojin',
    title: '进击的巨人',
    author: '谏山创',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20soldier%20with%20maneuver%20gear%20flying%20through%20the%20air%20against%20a%20giant%20titan%2C%20dark%20and%20dramatic%20mood%2C%20brown%20and%20crimson%20color%20palette%2C%20intense%20action%20scene%2C%20clean%20minimal%20background%2C%20professional%20manga%20illustration&width=800&height=1100&seq=manga-cover-04&orientation=portrait',
    description: '107年前，世界上突然出现了人类的天敌"巨人"。面临着生存危机而残存下来的人类逃到了一个地方，盖起了三重巨大的城墙。人们在这隔绝的环境里享受了一百多年的和平，直到艾伦·耶格尔10岁那年，60米高的"超大型巨人"突然出现，以压倒性的力量破坏城门，其后瞬间消失，凶残的巨人们成群的冲进墙内捕食人类。艾伦亲眼看着人们以及自己的母亲被巨人吞食，怀着对巨人无法形容的憎恨和痛恨，誓言杀死所有巨人。',
    status: '已完结',
    category: '日漫',
    tags: ['黑暗', '战斗', '悬疑', '剧情'],
    rating: 9.8,
    views: 18900000,
    updatedAt: '2026-06-15',
    chapters: Array.from({ length: 139 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-06-15',
    })),
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    slug: 'spy-family',
    title: '间谍过家家',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20a%20family%20of%20three%20with%20a%20man%20in%20suit%2C%20a%20woman%20with%20red%20hair%2C%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20family%20comedy%20vibe%2C%20soft%20pastel%20colors%20with%20pink%20and%20cream%20tones%2C%20clean%20minimal%20background%2C%20heartwarming%20manga%20style&width=800&height=1100&seq=manga-cover-05&orientation=portrait',
    description: '为了潜入名校，西国能力最强的间谍「黄昏」被下令组建家庭。但是，他的「女儿」居然是能够读取他人内心的超能力者！「妻子」是暗杀者？互相隐藏了真实身份的新家庭，面临考验与世界危机的痛快家庭喜剧就此展开！',
    status: '连载中',
    category: '日漫',
    tags: ['搞笑', '家庭', '间谍', '温馨'],
    rating: 9.4,
    views: 12500000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-01',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '6',
    slug: 'chainsaw-man',
    title: '链锯人',
    author: '藤本树',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20young%20man%20with%20chainsaw%20blades%20protruding%20from%20his%20head%20and%20arms%2C%20blood%20splatter%20effects%2C%20dark%20urban%20setting%2C%20orange%20and%20black%20color%20scheme%2C%20punk%20aesthetic%2C%20clean%20minimal%20background%20with%20gradient%2C%20professional%20manga%20art&width=800&height=1100&seq=manga-cover-06&orientation=portrait',
    description: '淀治是个背负了父亲遗留下的庞大债务，因此过着极端贫穷生活的少年，他救了恶魔波奇塔，并与它一起以恶魔猎人的身份斩杀低阶恶魔来换取酬劳。有一天，流氓骗了淀治，让他成为被恶魔吞噬的对象，淀治在临死之际，波奇塔牺牲自己，把心脏给了他，让他复活并拥有了恶魔的力量，只要拉下位在心脏那边的链子就能发动。之后淀治被公安人员看上，因此成为公安的恶魔猎人。',
    status: '连载中',
    category: '日漫',
    tags: ['黑暗', '战斗', '恶魔', '都市'],
    rating: 9.3,
    views: 11500000,
    updatedAt: '2026-07-30',
    chapters: Array.from({ length: 178 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-30',
    })),
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    slug: 'frieren',
    title: '葬送的芙莉莲',
    author: '山田钟人',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20an%20elf%20girl%20with%20long%20silver%20hair%20and%20a%20staff%2C%20standing%20in%20a%20peaceful%20flower%20field%2C%20soft%20pastel%20colors%20with%20gentle%20lighting%2C%20melancholic%20yet%20beautiful%20fantasy%20atmosphere%2C%20clean%20composition%2C%20professional%20manga%20art%20quality&width=800&height=1100&seq=manga-cover-07&orientation=portrait',
    description: '魔法使芙莉莲与勇者辛美尔等人历经10年的冒险，打败了魔王，为世界带来了和平。身为精灵族的她与其他三人有着截然不同的寿命。芙莉莲透过"那之后"的冒险，逐渐理解到了人类的"情感"，并踏上"了解人类"的旅程。同一时间，她与勇者一行人往昔的回忆与故事也逐渐揭晓。',
    status: '连载中',
    category: '日漫',
    tags: ['奇幻', '冒险', '治愈', '剧情'],
    rating: 9.7,
    views: 9800000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 136 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-03',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '8',
    slug: 'oshi-no-ko',
    title: '我推的孩子',
    author: '赤坂明 × 横枪萌果',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20a%20beautiful%20idol%20girl%20with%20long%20purple%20hair%20and%20star%20eyes%2C%20sparkling%20stage%20lights%20background%2C%20glamorous%20entertainment%20industry%20aesthetic%2C%20soft%20pink%20and%20white%20color%20scheme%2C%20clean%20composition%2C%20professional%20manga%20art&width=800&height=1100&seq=manga-cover-08&orientation=portrait',
    description: '在乡下工作的妇产科医生五郎，有一天他所推崇的偶像"B小町"成员·星野爱出现在了他的面前。她怀有身孕，而且还是双胞胎。五郎决心要守护她，但就在爱即将分娩之际，五郎被神秘人杀害。当他再次睁开眼睛时，竟然转生为了爱的孩子——其中的一个婴儿！隐藏着秘密的演艺圈，以全新视角展开的娱乐圈故事就此开始。',
    status: '连载中',
    category: '日漫',
    tags: ['娱乐圈', '转生', '悬疑', '剧情'],
    rating: 9.2,
    views: 8700000,
    updatedAt: '2026-07-29',
    chapters: Array.from({ length: 162 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-29',
    })),
    isHot: false,
    isNew: false,
  },
  // 韩漫
  {
    id: '9',
    slug: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20handsome%20black-haired%20young%20man%20with%20glowing%20purple%20eyes%20and%20dark%20armor%2C%20surrounded%20by%20shadow%20soldiers%2C%20dark%20fantasy%20aesthetic%2C%20dramatic%20lighting%20from%20below%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20art%20quality&width=800&height=1100&seq=manga-cover-09&orientation=portrait',
    description: '10年前，世界与其他次元连接的「门」被打开，随之而来的是被称为「猎人」的超能力者的觉醒。然而，并不是所有的猎人都很强大。被称为「人类最弱兵器」的E级猎人成振宇，在一次突袭地下城的过程中，遭遇了意想不到的试炼。在濒死之际，他接受了一个神秘的任务——「玩家成振宇，您已获得升级系统」。从此，他的命运发生了翻天覆地的变化。',
    status: '已完结',
    category: '韩漫',
    tags: ['升级', '战斗', '奇幻', '逆袭'],
    rating: 9.7,
    views: 20100000,
    updatedAt: '2026-05-20',
    chapters: Array.from({ length: 179 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-05-20',
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    slug: 'omniscient-reader',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20illustration%20of%20an%20ordinary%20office%20worker%20holding%20a%20glowing%20smartphone%20in%20an%20apocalyptic%20cityscape%2C%20constellation%20stars%20in%20the%20night%20sky%2C%20blue%20and%20gold%20color%20palette%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20art&width=800&height=1100&seq=manga-cover-10&orientation=portrait',
    description: '「生存的方法只有我知道。」平凡上班族金独子唯一的乐趣就是阅读网络小说《在灭亡的世界中存活的三种方法》。在长达十年的连载后，这部小说终于迎来了结局。然而，就在他读完最后结局的瞬间，小说中的世界竟然变成了现实。目睹着小说开头场景的他，决定利用已知的信息，在这个毁灭的世界中生存下去。',
    status: '连载中',
    category: '韩漫',
    tags: ['末世', '系统', '生存', '剧情'],
    rating: 9.6,
    views: 13200000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 220 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-02',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '11',
    slug: 'villain-aesthetics',
    title: '反派的美学',
    author: 'LIAM / BEOMKU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20an%20elegant%20nobleman%20with%20blonde%20hair%20and%20red%20eyes%2C%20wearing%20luxurious%20Victorian%20attire%2C%20rose%20petals%20floating%2C%20dark%20romance%20fantasy%20aesthetic%2C%20deep%20red%20and%20gold%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20art&width=800&height=1100&seq=manga-cover-11&orientation=portrait',
    description: '穿越到了自己最讨厌的小说中，成为了终将被主角杀死的恶毒反派。为了生存，她决定改变故事的走向。然而，越是想要远离主角，命运却越是把她推向漩涡的中心。在这个充满阴谋与背叛的贵族世界中，她能否改写自己的结局？',
    status: '连载中',
    category: '韩漫',
    tags: ['穿越', '恋爱', '宫廷', '逆袭'],
    rating: 9.3,
    views: 8500000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 145 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-01',
    })),
    isHot: false,
    isNew: true,
  },
  {
    id: '12',
    slug: 'return-of-mount-hua',
    title: '剑尊归来',
    author: 'Biga / STUDIO LICO',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20illustration%20of%20a%20young%20swordsman%20with%20long%20black%20hair%20in%20traditional%20martial%20arts%20robe%2C%20holding%20a%20sword%20with%20cherry%20blossom%20petals%2C%20ancient%20Chinese%20mountain%20temple%20background%2C%20soft%20pink%20and%20white%20color%20scheme%2C%20clean%20minimal%20composition%2C%20professional%20webtoon%20art&width=800&height=1100&seq=manga-cover-12&orientation=portrait',
    description: '华山派的天才剑客青云，在与魔教的最后一战中陨落。百年后，他奇迹般地在一个落魄少年的身体中醒来。华山派已经从昔日的武林至尊沦落到了随时可能被解散的境地。为了重振华山的威名，青云必须重新开始修炼，一步一步重新攀登武道的巅峰。',
    status: '连载中',
    category: '韩漫',
    tags: ['武侠', '重生', '热血', '战斗'],
    rating: 9.5,
    views: 10800000,
    updatedAt: '2026-07-31',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-31',
    })),
    isHot: true,
    isNew: false,
  },
  // 国漫
  {
    id: '13',
    slug: 'doupo-cangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆 / 任翔',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20young%20man%20with%20black%20hair%20holding%20a%20heavy%20ruler%20weapon%2C%20surrounded%20by%20colorful%20flames%2C%20fantasy%20cultivation%20world%20aesthetic%2C%20golden%20and%20red%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20manhua%20art%20quality&width=800&height=1100&seq=manga-cover-13&orientation=portrait',
    description: '这里是属于斗气的世界，没有花俏艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！萧炎，昔日天才少年，如今却被称为废物。当他不堪受辱，准备离开家族时，一缕幽魂从他手上的戒指里浮现，一扇全新的大门就此开启。且看萧炎如何从废物逆袭成为巅峰强者！',
    status: '连载中',
    category: '国漫',
    tags: ['玄幻', '修炼', '逆袭', '热血'],
    rating: 9.4,
    views: 18200000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 568 }, (_, i) => ({
      id: `ch-13-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-03',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '14',
    slug: 'wanmei-shijie',
    title: '完美世界',
    author: '辰东',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20young%20boy%20with%20wild%20hair%20riding%20a%20mythical%20beast%20in%20a%20primordial%20forest%2C%20ancient%20Chinese%20mythology%20aesthetic%2C%20green%20and%20gold%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20manhua%20art&width=800&height=1100&seq=manga-cover-14&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？一个少年从大荒中走出，一切从这里开始。',
    status: '连载中',
    category: '国漫',
    tags: ['玄幻', '异世', '热血', '修真'],
    rating: 9.3,
    views: 16500000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 512 }, (_, i) => ({
      id: `ch-14-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-02',
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: '15',
    slug: 'quanzhi-gaoshou',
    title: '全职高手',
    author: '蝴蝶蓝 / 常盘勇者',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20cool%20esports%20player%20with%20headphones%20holding%20a%20keyboard%2C%20digital%20gaming%20background%20with%20neon%20lights%2C%20silver%20and%20blue%20color%20scheme%2C%20modern%20competitive%20gaming%20aesthetic%2C%20clean%20minimal%20background%2C%20professional%20manhua%20art&width=800&height=1100&seq=manga-cover-15&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆，和一把未完成的自制银武——千机伞，开始了重返巅峰之路。',
    status: '已完结',
    category: '国漫',
    tags: ['电竞', '竞技', '热血', '逆袭'],
    rating: 9.5,
    views: 12100000,
    updatedAt: '2026-04-18',
    chapters: Array.from({ length: 288 }, (_, i) => ({
      id: `ch-15-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-04-18',
    })),
    isHot: false,
    isNew: false,
  },
  {
    id: '16',
    slug: 'huli-xiaohongniang',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20fox%20ears%20and%20nine%20tails%2C%20wearing%20traditional%20red%20Chinese%20dress%2C%20cherry%20blossom%20and%20moonlight%20background%2C%20soft%20romantic%20fantasy%20aesthetic%2C%20pink%20and%20white%20color%20scheme%2C%20clean%20minimal%20composition%2C%20professional%20manhua%20art&width=800&height=1100&seq=manga-cover-16&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死了，妖还活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖若痴情，就去找狐妖"购买"一项服务，让投胎转世的人回忆起前世的爱。白月初——史上最穷最没有节操的道士，与狐妖转世的苏苏相遇了。',
    status: '连载中',
    category: '国漫',
    tags: ['恋爱', '奇幻', '搞笑', '古风'],
    rating: 9.4,
    views: 13600000,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 420 }, (_, i) => ({
      id: `ch-16-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-28',
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: '17',
    slug: 'yiren-zhixia',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20college%20student%20boy%20using%20supernatural%20martial%20arts%20with%20glowing%20energy%2C%20modern%20urban%20Chinese%20setting%2C%20mysterious%20taoist%20elements%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20manhua%20art&width=800&height=1100&seq=manga-cover-17&orientation=portrait',
    description: '随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，和没有任何记忆的"不死少女"冯宝宝一起，开启了"异人"之旅。在这个充满异能者的世界中，一个关于道教、气功与超能力的故事就此展开。',
    status: '连载中',
    category: '国漫',
    tags: ['异能', '都市', '道家', '剧情'],
    rating: 9.6,
    views: 14800000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 350 }, (_, i) => ({
      id: `ch-17-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-08-01',
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: '18',
    slug: 'zhenhun-jie',
    title: '镇魂街',
    author: '许辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20young%20man%20summoning%20a%20giant%20guardian%20spirit%20warrior%20in%20ancient%20armor%2C%20supernatural%20battle%20scene%2C%20dark%20and%20golden%20color%20palette%2C%20clean%20minimal%20background%2C%20professional%20manhua%20art%20quality&width=800&height=1100&seq=manga-cover-18&orientation=portrait',
    description: '镇魂街，此乃吸纳亡灵镇压恶灵之地。这是一个人灵共存的世界。普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，因此误入罗刹街并遭到了危险，幸而被镇魂将曹焱兵搭救。然而接触中，曹焱兵却发现夏铃并非看起来那样普通，因为她的身体里也存在着灵力。',
    status: '连载中',
    category: '国漫',
    tags: ['奇幻', '战斗', '守护', '热血'],
    rating: 9.2,
    views: 9500000,
    updatedAt: '2026-07-25',
    chapters: Array.from({ length: 298 }, (_, i) => ({
      id: `ch-18-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-07-25',
    })),
    isHot: false,
    isNew: false,
  },
];

export const hotManga = allManga.filter((m) => m.isHot).map((m, i) => ({ ...m, rank: i + 1 }));
export const newManga = allManga.filter((m) => m.isNew);
export const completedManga = allManga.filter((m) => m.status === '已完结');

export const categories = [
  { slug: 'all', label: '全部', icon: 'ri-apps-line' },
  { slug: 'japanese', label: '日漫', icon: 'ri-sun-line' },
  { slug: 'korean', label: '韩漫', icon: 'ri-star-line' },
  { slug: 'chinese', label: '国漫', icon: 'ri-flag-line' },
  { slug: 'completed', label: '已完结', icon: 'ri-check-double-line' },
] as const;

export function getMangaBySlug(slug: string): MangaData | undefined {
  return allManga.find((m) => m.slug === slug);
}

export function getMangaByCategory(slug: string): MangaData[] {
  if (slug === 'all') return allManga;
  if (slug === 'japanese') return allManga.filter((m) => m.category === '日漫');
  if (slug === 'korean') return allManga.filter((m) => m.category === '韩漫');
  if (slug === 'chinese') return allManga.filter((m) => m.category === '国漫');
  if (slug === 'completed') return completedManga;
  return allManga;
}

export function getRelatedManga(currentSlug: string, limit: number = 6): MangaData[] {
  const current = getMangaBySlug(currentSlug);
  if (!current) return allManga.slice(0, limit);
  return allManga
    .filter((m) => m.slug !== currentSlug && m.category === current.category)
    .slice(0, limit);
}